<template>
  <div class="broadcast-call-page">
    <div class="top-container">
      <!-- <div class="type" style="margin: 12px 0 6px" v-if="false">
        <span>广播范围：</span>
        <el-radio-group
          style="margin-left: 16px"
          v-model="selectDistance"
          size="mini"
          @change="getTreeList"
        >
          <el-radio-button label="-1">全部</el-radio-button>
          <el-radio-button label="30"></el-radio-button>
          <el-radio-button label="50"></el-radio-button>
          <el-radio-button label="100"></el-radio-button>
          <el-radio-button label="200"></el-radio-button>
        </el-radio-group>
      </div> -->
      <div class="call-area intercom">
        <div class="alarmTool-call intercom" style="z-index: 3">
          <div class="intercom-title">
            远程喊话【{{
              remoteCallInfo.processing ? "正在喊话" : "暂停喊话"
            }}】
          </div>
          |
          <template
            v-if="remoteCallInfo.deviceList && remoteCallInfo.deviceList.length"
          >
            <div
              class="intercom-device"
              @mouseover="remoteCallInfo.showDeviceList = true"
              @mouseout="remoteCallInfo.showDeviceList = false"
            >
              <div class="intercom-device-item click-able">
                <i class="iconfont-lunan icon-lunan-radio"></i>
                <div
                  :title="remoteCallInfo.deviceList[0].name"
                  class="device-name"
                  @click="handleMapCenter(remoteCallInfo.deviceList[0])"
                >
                  {{ remoteCallInfo.deviceList[0].name }}
                </div>
                <i
                  v-if="remoteCallInfo.deviceList.length > 1"
                  class="el-icon-caret-bottom device-expand-icon"
                  :class="{
                    expand: remoteCallInfo.showDeviceList,
                  }"
                ></i>
              </div>
              <div
                class="device-list-area bottom map-blur-panel__title"
                :style="{
                  height: (remoteCallInfo.deviceList.length - 1) * 30 + 'px',
                }"
                :class="{ hidden: !remoteCallInfo.showDeviceList }"
              >
                <el-scrollbar style="height: 100%">
                  <template v-for="(item, index) in remoteCallInfo.deviceList">
                    <div
                      v-if="index !== 0"
                      class="intercom-device-item click-able"
                      :key="'intercom-device-' + index"
                      :title="item.name"
                      @click="handleMapCenter(item)"
                    >
                      <i class="iconfont-lunan icon-lunan-radio"></i>
                      <div class="device-name" :title="item.name">
                        {{ item.name }}
                      </div>
                    </div>
                  </template>
                </el-scrollbar>
              </div>
            </div>
            <div class="intercom-operate">
              <div class="click-able operate-btn" @click="toggleStopIntercom">
                <el-tooltip
                  :content="remoteCallInfo.processing ? '停止喊话' : '继续喊话'"
                  effect="dark"
                  placement="top"
                >
                  <i
                    :class="
                      remoteCallInfo.processing
                        ? 'el-icon-video-pause play-icon'
                        : 'el-icon-video-play stop-icon'
                    "
                  ></i>
                </el-tooltip>
              </div>
            </div>
            <div
              class="intercom-volume"
              :class="{ 'click-able': remoteCallInfo.processing }"
              @mouseover="remoteCallInfo.showVolume = remoteCallInfo.processing"
              @mouseout="remoteCallInfo.showVolume = false"
            >
              <div class="intercom-volume-bar active">
                <el-slider
                  v-model="remoteCallInfo.broadcastVolume"
                  max="15"
                  @change="
                    (val) => {
                      handleVoice(val, remoteCallInfo.deviceList);
                    }
                  "
                ></el-slider>
              </div>
              <i class="iconfont-lunan icon-lunan-guangbo"></i>
            </div>
            <el-tooltip content="关闭喊话" effect="dark" placement="top-start">
              <div
                class="intercom-close click-able"
                @click="handleClosePlay(1)"
              >
                <i class="el-icon-close"></i>
              </div>
            </el-tooltip>
          </template>
          <template v-else>
            <div class="intercom-device">
              <div class="device-name">无广播设备</div>
            </div>
          </template>
        </div>
        <!-- 播放音频 -->
        <div class="alarmTool-call intercom">
          <div class="intercom-title">
            播放音频【{{
              audioDeviceInfo.processing ? "正在播放" : "暂停播放"
            }}】
          </div>
          |
          <template
            v-if="
              audioDeviceInfo.deviceList && audioDeviceInfo.deviceList.length
            "
          >
            <div
              class="intercom-device"
              @mouseover="audioDeviceInfo.showDeviceList = true"
              @mouseout="audioDeviceInfo.showDeviceList = false"
            >
              <div class="intercom-device-item click-able">
                <i class="iconfont-lunan icon-lunan-radio"></i>
                <div
                  :title="audioDeviceInfo.deviceList[0].name"
                  class="device-name"
                  @click="handleMapCenter(audioDeviceInfo.deviceList[0])"
                >
                  {{ audioDeviceInfo.deviceList[0].name }}
                </div>
                <i
                  v-if="audioDeviceInfo.deviceList.length > 1"
                  class="el-icon-caret-bottom device-expand-icon"
                  :class="{
                    expands: audioDeviceInfo.showDeviceList,
                  }"
                ></i>
              </div>
              <div
                class="device-list-area bottom map-blur-panel__title"
                :style="{
                  height: (audioDeviceInfo.deviceList.length - 1) * 30 + 'px',
                }"
                :class="{ hidden: !audioDeviceInfo.showDeviceList }"
              >
                <el-scrollbar style="height: 100%">
                  <template v-for="(item, index) in audioDeviceInfo.deviceList">
                    <div
                      v-if="index !== 0"
                      class="intercom-device-item click-able"
                      :key="'intercom-device-' + index"
                      :title="item.name"
                      @click="handleMapCenter(item)"
                    >
                      <i class="iconfont-lunan icon-lunan-radio"></i>
                      <div class="device-name" :title="item.name">
                        {{ item.name }}
                      </div>
                    </div>
                  </template>
                </el-scrollbar>
              </div>
            </div>
            <div class="intercom-operate">
              <template>
                <div class="audio-button">
                  <el-tooltip content="上一首" effect="dark">
                    <i
                      class="click-able el-icon-arrow-left audio-button"
                      @click="controlPlayAudio('previous')"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    :content="audioDeviceInfo.processing ? '暂停' : '播放'"
                    effect="dark"
                  >
                    <i
                      @click="
                        controlPlayAudio(
                          audioDeviceInfo.processing ? 'pause' : 'play'
                        )
                      "
                      class="click-able audio-button"
                      :class="
                        audioDeviceInfo.processing
                          ? 'el-icon-video-pause play-icon'
                          : 'el-icon-video-play stop-icon'
                      "
                    ></i>
                  </el-tooltip>
                  <el-tooltip content="下一首" effect="dark">
                    <i
                      class="click-able el-icon-arrow-right audio-button"
                      @click="controlPlayAudio('next')"
                    ></i>
                  </el-tooltip>
                </div>
              </template>
            </div>
            <div
              class="intercom-volume"
              :class="{ 'click-able': audioDeviceInfo.processing }"
              @mouseover="
                audioDeviceInfo.showVolume = audioDeviceInfo.processing
              "
              @mouseout="audioDeviceInfo.showVolume = false"
            >
              <div class="intercom-volume-bar active">
                <el-slider
                  max="15"
                  v-model="audioDeviceInfo.broadcastVolume"
                  @change="
                    (val) => {
                      handleVoice(val, audioDeviceInfo.deviceList);
                    }
                  "
                ></el-slider>
              </div>
              <i class="iconfont-lunan icon-lunan-guangbo"></i>
            </div>
            <el-tooltip content="关闭音频" effect="dark" placement="bottom">
              <div
                class="intercom-close click-able"
                @click="handleClosePlay(2)"
              >
                <i class="el-icon-close"></i>
              </div>
            </el-tooltip>
          </template>
          <template v-else>
            <div class="intercom-device">
              <div class="device-name">无广播设备</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!--远程喊话,播放音频-->
    <Broadcast
      ref="refBroadcast"
      :broadcastPageType="broadcastPageType"
      :refMap="refMap"
      :layerId="constLayerId.broadcast"
      :showPanel="showBroadcast"
      :broadcastArray="broadcastList"
      @handleCloseBroadcast="handleCloseBroadcast"
      @handleSuccessBroadcast="handleSuccessBroadcast"
    />
  </div>
</template>
  
  <script>
import { api } from "@src/modules/broadcast/api";
import Broadcast from "@src/modules/realTimeAlarm/components/broadcast";
// import chooseIntercomSource from "@src/modules/broadcast/components/choose-intercom-source.vue";
export default {
  components: {
    // chooseIntercomSource,
    Broadcast,
  },
  props: {
    alarm: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showBroadcast: false,
      constLayerId: {
        broadcast: "BROAD_CAST_LAYER",
      },
      broadcastPageType: 2, //1广播喊话，2 播放音频
      refMap: null,
      broadcastCheckSrc: "images/theme/newDark/map/resource/broadcast-call.png", //广播喊话
      broadcastCheckPlaySrc:
        "images/theme/newDark/map/resource/broadcast-audio.png", //音频播放
      selectDistance: "",
      remoteCallInfo: {
        isEmpty: true,
        processing: false,
        showVolume: false,
        broadcastVolume: 30,
        showDeviceList: false,
        deviceList: [],
      },
      audioDeviceInfo: {
        isEmpty: true,
        processing: false,
        showVolume: false,
        broadcastVolume: 30,
        showDeviceList: false,
        deviceList: [],
        audioList: [],
        audioIndex: 0,
      },
      broadcastList: [],
    };
  },
  computed: {
    currentTheme() {
      return this.$store.getters.currentTheme;
    },
  },
  beforeDestroy() {
    this.$map.hideMap2D();
    this.$emit("leverCall");
  },
  mounted() {
    this.$map.showMap2D(this.initPage);
  },
  methods: {
    getTreeList() {
      if (!this.selectDistance) {
        return;
      }
      //   this.$map.MapInstance2D.clearLayer("checkDevice");
      this.$fetch("/bas/emergency/queryEmergencyDeviceList.json", {
        deviceType: "18",
        distance: this.selectDistance,
        emergencyRecordCode: this.alarm.emergencyRecordCode,
      }).then((response) => {
        if (response && response.success) {
          let deviceTableData = response.returnObj || [];
          let distanceList = deviceTableData.map((el) => {
            return {
              id: el.thirdCameraId, //el.thirdDeviceId,
              name: el.name,
              longitude: el.longitude,
              latitude: el.latitude,
            };
          });
          this.remoteCallInfo.deviceList = [...distanceList];
          let point = response.returnObj.map((item) => {
            return {
              id: item.thirdCameraId,
              coord: [Number(item.longitude), Number(item.latitude)],
              scale: 1.2,
              src: `images/theme/${this.currentTheme}/map/resource/broadcast_select.png`,
              attr: item,
              showTips: false,
            };
          });
          console.log(point);
          this.$map.MapInstance2D.addMarket(point, "checkDevice");
          // this.remoteCallInfo.deviceListCopy.concat(...distanceList);
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },

    initPage() {
      // 回显告警点
      this.refMap = this.$map.MapInstance2D;
      this.handleAddMarker();
      Promise.all([
        this.getRemoteCall(), //获取远程喊话
        this.getAudioDevice(), //获取播放音频
        this.getBroadcastList(), //广播设备
      ]).then((res) => {
        this.handleAddMarkBroadcast();
      });
    },
    handleAddMarkBroadcast() {
      let broadcastList = [];
      this.broadcastList.forEach((item) => {
        let obj = { ...item };
        let isAudio = this.remoteCallInfo.deviceList.some((el) => {
          return el.id == item.id;
        });
        let isCall = this.audioDeviceInfo.deviceList.some((el) => {
          return el.id == item.id;
        });
        let checkType = isAudio ? "audio" : isCall ? "call" : ""; //audio:音频播放设备，call:广播喊话设备
        item.checkType = checkType;
        obj.attr.checkType = checkType;
        obj.src =
          checkType == "audio"
            ? this.broadcastCheckPlaySrc
            : checkType == "call"
            ? this.broadcastCheckSrc
            : item.src;
        broadcastList.push(obj);
      });
      this.refMap.addMarket(
        broadcastList,
        this.constLayerId.broadcast,
        this.handleMapClick
      );
    },
    // 广播图层设备点击back
    handleMapClick(e) {
      console.log(e);
      // 创建广播喊话过程中不支持显示提示框
      let deviceType = e.marker.attr.deviceType;
      let checkType = e.marker.attr.checkType;
      if (this.showBroadcast && deviceType == 26) {
        // 远程和广播的设备不可以共用
        if (
          (this.broadcastPageType == 1 && checkType != "audio") ||
          (this.broadcastPageType == 2 && checkType != "call")
        ) {
          this.$refs.refBroadcast.handleDealDevice(e.marker.attr, {
            map: this.refMap,
            layerId: e.layerId,
            id: e.marker.id,
          });
          return;
        }
      }
      const tipID = "device_popup";
      this.refMap.addPopupMap({
        offset: [10, 12],
        position: e.marker.coord,
        content: '<div id="device_popup"></div>',
        contentId: tipID,
        layerId: tipID,
      });
      let deviceTip = new this.refMap.vueComponents.deviceDetailTip().$mount(
        "#" + tipID
      );
      deviceTip.data = e.marker.attr;
      deviceTip.$on("tipClose", () => {
        this.refMap.removePopup(tipID);
      });
      // 广播喊话
      deviceTip.$on("handleDeviceShout", (info) => {
        this.broadcastPageType = 1;
        this.handleShowBroadcast(e, info, tipID);
      });
      // 广播播放
      deviceTip.$on("handleDeviceMusic", (info) => {
        this.broadcastPageType = 2;
        this.handleShowBroadcast(e, info, tipID);
      });
    },
    handleShowBroadcast(e, info, tipID) {
      this.refMap.removePopup(tipID);
      if (this.broadcastPageType == 1) {
        let obj = {
          thirdDeviceId: this.alarm.sourceTerminalId,
          name: this.alarm.sourceTerminalName,
        };
        this.$refs.refBroadcast.handleConfirm(obj);
      }
      // 回显点击的设备
      if (this.showBroadcast == true) {
        this.$refs.refBroadcast.handleClosePanel();
        setTimeout(() => {
          this.showBroadcast = true;
          this.$refs.refBroadcast.handleDealDevice(info, {
            map: this.refMap,
            layerId: e.layerId,
            id: e.marker.id,
          });
        }, 200);
        return;
      }
      this.showBroadcast = true;
      this.$nextTick(() => {
        this.$refs.refBroadcast.handleDealDevice(info, {
          map: this.refMap,
          layerId: e.layerId,
          id: e.marker.id,
        });
      });
    },
    handleMapCenter(info) {
      console.log(info);
      this.refMap.setMapCenter([+info.longitude, +info.latitude]);
    },
    // 取消远程喊话弹窗
    handleCloseBroadcast() {
      this.showBroadcast = false;
      this.handleAddMarkBroadcast();
    },
    // 远程喊话/音频播放成功回调，1 喊话2 音频
    handleSuccessBroadcast(type) {
      if (type == 1) {
        //获取远程喊话
        this.getRemoteCall().then((res) => {
          this.handleAddMarkBroadcast();
        });
      } else {
        //获取播放音频设备
        this.getAudioDevice().then((res) => {
          this.handleAddMarkBroadcast();
        });
      }
      this.showTool = true;
    },
    handleAddMarker() {
      let centerPoint = [
        Number(this.alarm.longitude),
        Number(this.alarm.latitude),
      ];
      this.$map.MapInstance2D.positionByPoint(centerPoint);

      let alarmPoint = [
        {
          id: this.alarm.alarmId,
          coord: centerPoint,
          anchor: [20, 20],
          longitude: Number(this.alarm.longitude),
          latitude: Number(this.alarm.latitude),
          src: this.alarm.alarmId
            ? `images/theme/newDark/map/alarm_state/${this.alarm.alarmLevel}_1.png`
            : `images/theme/newDark/map/resource/position_alarm.png`,
        },
      ];
      this.$map.MapInstance2D.addMarket(alarmPoint, "alarm", () => {});
    },
    getBroadcastList() {
      this.broadcastList = [];
      const params = {
        // 广播设备类型为26
        deviceType: 26,
        page: 1,
        pageSize: 1000,
      };
      return new Promise((resolve) => {
        this.$fetch(api.getDeviceListByPage, params).then((res) => {
          if (res.success) {
            ((res.returnObj && res.returnObj.list) || []).forEach((item) => {
              let type = "";
              item.status == 0 ? (type = "_grey") : (type = "_inactive");
              let addMarkInfo = this.getMapPoint(item, type);
              this.broadcastList.push(addMarkInfo);
            });
            resolve(true);
          } else {
            this.$message.error(res.msgContent || "查询广播设备列表失败");
            resolve(true);
          }
        });
      });
    },
    // 获取远程喊话
    getRemoteCall() {
      return new Promise((resolve) => {
        this.$fetch(api.queryRemoteCall).then((res) => {
          this.isIntercomRefreshing = false;
          if (res.success) {
            let result = res.returnObj || {};
            let deviceList = (result.targetTerminalInfoList || []).map(
              (item) => {
                return {
                  id: item.targetTerminalId,
                  name: item.targetTerminalName,
                  longitude: item.longitude,
                  latitude: item.latitude,
                };
              }
            );
            this.remoteCallInfo = {
              isEmpty: deviceList.length > 0 ? true : false,
              processing: result.stop === "0",
              showVolume: false,
              broadcastVolume: 30,
              showDeviceList: false,
              deviceList: deviceList,
              deviceListCopy: [...deviceList],
              sourceId: this.$parent.reserveDetail.sourceTerminalId, // result.sourceTerminalId,
              sourceName: this.$parent.reserveDetail.sourceTerminalName, //result.sourceTerminalName,
            };
            resolve(true);
          } else {
            this.$message.error(res.msgContent);
            this.remoteCallInfo.isEmpty = false;
            this.$log.error("查询远程喊话信息失败");
          }
        });
      });
    },
    getMapPoint(item, type = "") {
      let obj = {
        id: item.thirdDeviceId,
        thirdCameraId: item.thirdDeviceId, //为了和设备组设备编号保持一致
        coord: [Number(item.longitude), Number(item.latitude)],
        longitude: +item.longitude,
        latitude: +item.latitude,
        anchor: [10, 12],
        scale: 1,
        isHover: true,
        src: `images/theme/${this.currentTheme}/map/resource/broadcast${type}.png`,
        sleSrc: "images/theme/newDark/map/resource/broadcast-live_selected.png", //选中
        oldSrc: `images/theme/${this.currentTheme}/map/resource/broadcast${type}.png`, //默认图标
        name: item.deviceName,
        tipsTitle: "广播设备详情",
        showTips: true,
        tipsMap: {
          deviceName: "设备名称",
        },
      };
      obj.attr = Object.assign(item, obj);
      return obj;
    },
    // 操作远程喊话
    toggleStopIntercom() {
      console.log(this.remoteCallInfo);
      let params = {
        // 源终端ID
        sourceTerminalId: this.remoteCallInfo.sourceId,
        // 0 开始 1 停止， 如果当前是开始状态，则修改为'1'（停止）；如果当前是停止状态，则修改为'0'（开始）
        stop: this.remoteCallInfo.processing ? "1" : "0",
        //目标终端ID列表
        targetTerminalIdList: this.remoteCallInfo.deviceList.map((item) => {
          return item.id;
        }),
      };
      this.$fetch(api.manualRemoteCall, params).then((res) => {
        if (res.success) {
          this.$message.success("操作成功");
          this.getRemoteCall();
        } else {
          this.$message.error(res.msgContent || "操作失败");
        }
      });
    },
    handleVoice(val, list) {
      let params = {
        terminalIdList: list.map((el) => {
          return el.id;
        }),
        volume: val,
      };
      this.$fetch(api.setVolume, params).then((res) => {
        if (res.success) {
          this.$message.success(`声音操作成功`);
        } else {
          this.$message.error(res.msgContent || `声音操作失败`);
        }
      });
    },
    handleClosePlay(type) {
      let url = type == 1 ? api.deleteRemoteCall : api.deletePlayAudio;
      let name = type == 1 ? "远程喊话" : "音频播放";

      this.$confirm("确认关闭" + name + "？", "确认关闭", {
        type: "warning",
      })
        .then((res) => {
          this.$fetch(url).then((res) => {
            if (res.success) {
              this.$message.success("操作成功");
              let deviceList =
                type == 1
                  ? this.remoteCallInfo.deviceList
                  : this.audioDeviceInfo.deviceList;
              this[type == 1 ? "remoteCallInfo" : "audioDeviceInfo"] = {
                deviceList: [],
                isEmpty: false,
              };
              // 恢复之前选中的广播
              this.handleAddMarkBroadcast();
            } else {
              this.$message.error(res.msgContent || "操作失败");
            }
          });
        })
        .catch((e) => {
          this.$log.debug("用户取消操作");
        });
    },
    // 控制音频播放
    controlPlayAudio(controlType) {
      let optStr = {
        play: "恢复播放",
        pause: "暂停播放",
        next: "音频播放下一首",
        previous: "音频播放上一首",
      };
      let params = {
        // 控制类型： play: 播放 pause: 暂停 next: 下一首 previous: 上一首
        controlType: controlType,
        // 播放状态 startbct(开始广播) stopbct（停止广播）filecontrol （ 播放控制）  此接口固定传filecontrol（ 播放控制）
        rtType: "filecontrol",
        // 广播ID列表
        terminalIdList: this.audioDeviceInfo.deviceList.map((item) => {
          return item.id;
        }),
      };
      this.$fetch(api.controlPlayAudio, params).then((res) => {
        if (res.success) {
          this.$message.success(`${optStr[controlType]}成功`);
          this.getAudioDevice();
        } else {
          this.$message.error(res.msgContent || `${optStr[controlType]}失败`);
        }
      });
    },
    getAudioDevice() {
      return new Promise((resolve) => {
        this.$fetch(api.queryPlayAudio).then((res) => {
          this.isPlayRefreshing = false;
          if (res.success) {
            let result = res.returnObj || {};
            let deviceList = (result.terminalInfoList || []).map((item) => {
              return {
                id: item.terminalId,
                name: item.terminalName,
                longitude: item.longitude,
                latitude: item.latitude,
              };
            });
            this.audioDeviceInfo = {
              isEmpty: deviceList.length > 0 ? true : false,
              processing: result.controlType && result.controlType != "pause",
              showVolume: false,
              broadcastVolume: 30,
              showDeviceList: false,
              deviceList: deviceList,
              sourceId: result.sourceTerminalId,
              sourceName: result.sourceTerminalName,
              audioList: [],
              audioIndex: 0,
            };
            resolve(true);
          } else {
            resolve(true);
            this.audioDeviceInfo.isEmpty = false;
            this.$log.error("查询音频播放信息失败");
          }
        });
      });
    },
    previousAudio() {
      this.controlPlayAudio("previous");
    },
    nextAudio() {
      this.controlPlayAudio("next");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.broadcast-call-page {
  // position: relative;
  width: 100%;
  .showPanel {
    right: -725px !important;
  }
  .broadcast-page {
    right: -375px;
  }
  .text-right {
    text-align: right;
  }

  .text-center {
    text-align: center;
  }

  .hidden-item {
    visibility: hidden;
  }

  .no-data-text {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .top-container {
    position: absolute;
    left: 12px;
    top: 0;
    height: 80px;
    width: 100%;
    z-index: 2;
    background: rgba(11, 18, 35, 0.35);
    backdrop-filter: blur(3px);
    padding: 6px 12px;
    // display: flex;
    // align-items: center;
  }
  .alarmTool-call {
    height: 30px;
    padding: 0 10px;
    // width: 650px;
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: row;
    align-items: center;
    z-index: 2;
    &.intercom {
      top: 10px;
      margin-bottom: 6px;
    }
    &.play {
      bottom: 10px;
    }
    .intercom-title {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 150px;
    }

    .intercom-device {
      max-width: 200px;
      // margin-right: 10px;
      // padding-right: 10px;
      position: relative;
      .intercom-device-item {
        display: flex;
        flex-direction: row;
        padding: 7px 10px;
        width: 165px;
      }
      .device-expand-icon {
        @include set_animation(transform);

        &.expand {
          transform: rotate(180deg);
        }
      }
      .device-list-area {
        position: absolute;
        overflow: hidden;
        max-height: 180px;
        left: 0;
        width: 100%;
        @include set_theme_color(background-color, popper-bg-color);
        @include set_animation(height);

        &.hidden {
          height: 0 !important;
        }
        &.top {
          bottom: 30px;
        }
        &.bottom {
          top: 30px;
        }
      }
    }
    .device-name,
    .audio-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 0 5px;
    }
    .intercom-operate {
      width: 100px;
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      justify-content: center;
      font-size: 20px;
      &.has-bg {
        padding: 5px;
        border-radius: 3px;
        // @include set_theme_color(background-color, page-tab-item-active-color);
      }
      .operate-btn {
        display: flex;
        flex-direction: row;
      }
      .stop-icon {
        padding: 2px;
        // height: 16px;
        // width: 16px;
        border-radius: 9px;
        background-color: #ff0000;
      }

      .play-icon {
        padding: 2px;
        // height: 16px;
        // width: 16px;
        border-radius: 9px;
        background-color: green;
      }

      .operate-text {
        margin-left: 5px;
      }
    }

    .intercom-volume {
      padding: 0 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: not-allowed;
    }

    .intercom-volume-bar {
      width: 0;
      margin-right: 5px;
      overflow: hidden;
      @include set_animation(width);

      .el-slider {
        margin: 0 10px;
      }

      &.active {
        width: 100px;
      }
    }

    .intercom-close {
      height: 30px;
      width: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .click-able {
      cursor: pointer;

      &:hover {
        @include set_theme_color(color, main-theme-color);
      }
    }
  }
}
</style>
  